import { types as api } from '@mesa-labs/mesa-api';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type InvoiceQuarantinesState = {
  partnerId?: api.Partners;
  type?: api.InvoiceQuarantineType;
  requiredCorrection?: api.InvoiceQuarantineCorrection;
  status?: api.InvoiceQuarantineStatus;
};

export const initialState: InvoiceQuarantinesState = {
  partnerId: undefined,
  type: undefined,
  requiredCorrection: undefined,
  status: api.InvoiceQuarantineStatus.Pending,
};

const invoiceQuarantinesSlice = createSlice({
  name: 'invoiceQuarantines',
  initialState,
  reducers: {
    updatePartnerId(state: InvoiceQuarantinesState, action: PayloadAction<api.Partners | undefined>) {
      state.partnerId = action.payload;
    },
    updateType(state: InvoiceQuarantinesState, action: PayloadAction<api.InvoiceQuarantineType | undefined>) {
      state.type = action.payload;
    },
    updateRequiredCorrection(state: InvoiceQuarantinesState, action: PayloadAction<api.InvoiceQuarantineCorrection | undefined>) {
      state.requiredCorrection = action.payload;
    },
    updateStatus(state: InvoiceQuarantinesState, action: PayloadAction<api.InvoiceQuarantineStatus | undefined>) {
      state.status = action.payload;
    },
  },
});

export const {
  updatePartnerId,
  updateType,
  updateRequiredCorrection,
  updateStatus,
} = invoiceQuarantinesSlice.actions;
export default invoiceQuarantinesSlice.reducer;
